module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticloadbalancingv2-2015-12-01.paginators.json
// module id = 668
// module chunks = 1